import MeetingMW from "@/middlewares/Meeting";
import MeetingORM from "@/store/orm-axios/models/Meeting";

import MandateMW from "@/middlewares/Mandate";
import MandateORM from "@/store/orm-axios/models/Mandate";

export default {
  data() {
    return {};
  },
  methods: {
    promptPresenceType(meeting) {
      return new Promise((resolve, reject) => {
        if (!meeting.allowed_modalities.physical) {
          resolve("video");
        } else if (!meeting.allowed_modalities.video) {
          resolve("physical");
        } else {
          const presenceTypes = {
            video: "Vidéo",
            physical: "Physique",
          };
          this.$swal({
            title: "Quel type de présence ?",
            input: "radio",
            inputOptions: presenceTypes,
            inputValidator: value => {
              if (!value) {
                return "Vous devez choisir quelque chose !";
              }
            },
          })
            .then(res => {
              resolve(res.value);
            })
            .catch(err => {
              reject(err);
            });
        }
      });
    },
    setMandatePresenceStatus(mandate, status, saveInDb = true, dummyVideoPresenceStatus = false) {
      return new Promise((resolve, reject) => {
        MandateORM.update({
          where: mandate.id,
          data: {
            presence_status: this.mandatePresenceStatuses[status],
            dummy_video_presence_status: dummyVideoPresenceStatus ? 1 : 0,
          },
        });
        // save in db
        var m = MandateORM.query().where("id", mandate.id).first();
        if (saveInDb) {
          MandateMW.PUT(m, false)
            .then(res => {
              resolve(res);
            })
            .catch(err => {
              reject(err);
            });
        } else {
          resolve(m);
        }
      });
    },
    setParticipantArrivedMandateStatus(mandate, status) {},
  },
};
